var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOpenCameraIcon = function SvgOpenCameraIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#555"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22 10.75h-2.212a.38.38 0 0 1-.277-.122l-1.15-1.256a.38.38 0 0 0-.276-.122h-4.17a.38.38 0 0 0-.276.122l-1.15 1.256a.38.38 0 0 1-.277.122H10a1.5 1.5 0 0 0-1.5 1.5v8.25A1.5 1.5 0 0 0 10 22h12a1.5 1.5 0 0 0 1.5-1.5v-8.25a1.5 1.5 0 0 0-1.5-1.5m0 9.375a.375.375 0 0 1-.375.375h-11.25a.375.375 0 0 1-.375-.375v-7.5c0-.207.168-.375.375-.375h2.497a.38.38 0 0 0 .277-.122l1.15-1.256a.38.38 0 0 1 .276-.122h2.85c.105 0 .206.044.276.122l1.15 1.256a.38.38 0 0 0 .277.122h2.497c.207 0 .375.168.375.375z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 13a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0 4.8a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6"
  })));
};
export default SvgOpenCameraIcon;